module.exports = __webpack_public_path__ + "static/media/close-icon.18691c58.svg";